module.exports = __webpack_public_path__ + "media/src/images/styleguide/none-314a66a6689b9b8e784989fda8460f83.png";